import * as React from 'react';
import IntlProvider from './IntlProvider';
import { Provider as ReduxProvider } from 'react-redux';

type Props = {
    children: React.ReactNode;
    store: any;
};
const Provider = ({ children, store }: Props) => (
    <ReduxProvider store={store}>
        <IntlProvider locale="en">{children}</IntlProvider>
    </ReduxProvider>
);

export default Provider;
